"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function OpenIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("polygon", { points: "14.393 2.491 14.393 4.19 18.652 4.19 11.408 11.435 12.609 12.636 19.854 5.392 19.854 9.651 21.553 9.651 21.553 2.491 14.393 2.491" }),
        react_1.default.createElement("path", { d: "M18.7,19.451a.36.36,0,0,1-.358.359H4.505a.361.361,0,0,1-.359-.359V5.616a.36.36,0,0,1,.359-.358H9.9v-1.7H4.505A2.059,2.059,0,0,0,2.447,5.616V19.451a2.06,2.06,0,0,0,2.058,2.058H18.339A2.059,2.059,0,0,0,20.4,19.451V13.958H18.7Z" })));
}
exports.default = OpenIcon;
